(() => {
  if (window.perdidaLandingInitialized) return;
  window.perdidaLandingInitialized = true;

  const initializeSliders = (container = document) => {
    container.querySelectorAll('[data-perdida-slider]').forEach((slider) => {
      const wrapper = slider.closest('.perdida__slider');
      const isCards = slider.dataset.perdidaSlider === 'cards';

      Object.assign(slider, {
        slidesPerView: 1,
        spaceBetween: 24,
        breakpoints: isCards ? { 768: { slidesPerView: 3, spaceBetween: 32 } } : {},
        navigation: {
          prevEl: wrapper.querySelector('[data-perdida-prev]'),
          nextEl: wrapper.querySelector('[data-perdida-next]'),
        },
        pagination: { clickable: true },
      });

      slider.initialize();
    });
  };

  const scrollToHash = () => {
    const target = location.hash && document.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (target) target.scrollIntoView();
  };

  customElements.whenDefined('swiper-container').then(() => {
    initializeSliders();
    scrollToHash();
  });

  document.addEventListener('shopify:section:load', (event) => {
    customElements.whenDefined('swiper-container').then(() => initializeSliders(event.target));
  });

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('.perdida__faq-toggle');
    if (!toggle) return;

    const isOpen = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.closest('.perdida__faq-list').querySelectorAll('.perdida__faq-toggle').forEach((item) => {
      const expanded = item === toggle && isOpen;
      item.setAttribute('aria-expanded', String(expanded));
      document.getElementById(item.getAttribute('aria-controls')).hidden = !expanded;
      item.closest('.perdida__faq-item').classList.toggle('is-expanded', expanded);
    });
  });
})();
